(() => {
  const cards = new WeakMap();
  const selector = '.card__color-link';

  function update(card, state) {
    const link = state.hovered || state.focused;
    if (state.link === link) return;
    state.link = link;
    const request = ++state.request;
    state.image?.remove();
    state.image = null;
    card.classList.remove('card--color-preview');

    const media = card.querySelector('.card__media .media');
    if (!media || !link?.dataset.colorPreviewSrc) return;

    // Keep the native image visible until the requested color has loaded.
    const image = new Image();
    image.className = 'card__color-preview motion-reduce';
    image.alt = link.dataset.colorPreviewAlt || '';
    image.setAttribute('aria-hidden', 'true');
    image.onload = () => {
      if (state.request !== request || !card.isConnected) return;
      state.image = image;
      media.append(image);
      card.classList.add('card--color-preview');
    };
    image.src = link.dataset.colorPreviewSrc;
  }

  function handle(event) {
    if (event.pointerType === 'touch') return;
    const link = event.target.closest?.(selector);
    const card = link?.closest('.product-card-wrapper');
    if (!card || link.contains(event.relatedTarget)) return;
    let state = cards.get(card);
    if (!state) {
      state = { request: 0 };
      cards.set(card, state);
    }
    const entering = event.type === 'pointerover' || event.type === 'focusin';
    const key = event.type.startsWith('focus') ? 'focused' : 'hovered';
    state[key] = entering ? link : null;
    update(card, state);
  }

  // Delegation also covers cards replaced by filtering or section rendering.
  ['pointerover', 'pointerout', 'focusin', 'focusout'].forEach((type) => document.addEventListener(type, handle));
})();
